import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
// The supportedFeatures obj holds an array of out features and some info about them.
import { supportedFeatures } from "../SupportedFeatures"
import "./SupportedFeatures.css"

interface ParentModalProps {
    showModal: boolean;
    handleCloseModal: () => void;
}

const ParentModal: React.FC<ParentModalProps> = ({
    showModal,
    handleCloseModal,
}) => {

    // State for parent modal.
    const [modalHasMounted, setModalHasMounted] = useState(false);

    // Hover conditional variables.
    const [hoveredImageAlt, setHoveredImageAlt] = useState<string | null>(null);
    const [hoverBoxPos, setHoverBoxPos] = useState<{ top: number; left: number } | null>(null);

    // If child needs to be rendered above to fit on screen.
    const [renderAbove, setRenderAbove] = useState(false);

    // Prevents the description from popping up early if mouse happens
    // to be over the container on launch.
    useEffect(() => {
        if (showModal) {
            const timer = setTimeout(() => {
                setModalHasMounted(true);
            }, 300);

            return () => clearTimeout(timer);
        } else {
            setModalHasMounted(false);
        }
    }, [showModal]);

    return (
        <>
            {/* Parent Modal */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Supported Features</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-image-container">
                        {supportedFeatures.map((image, index) => (
                            <div
                                className="modal-individual-image-container"
                                key={index}
                                onMouseEnter={(e) => {
                                    if (!modalHasMounted) return;

                                    // Dynamic positioning for child modal
                                    const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
                                    const tooltipHeight = 60; // adjust based on the modal content height
                                    const margin = 8; // spacing between image and description
                                    const screenHeight = window.innerHeight;

                                    const willBeCutOff = rect.bottom + tooltipHeight + margin > screenHeight;

                                    setRenderAbove(willBeCutOff);
                                    setHoveredImageAlt(image.alt);
                                    setHoverBoxPos({
                                        top: willBeCutOff ? rect.top + window.scrollY : rect.bottom + window.scrollY,
                                        left: rect.left + rect.width / 2,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setHoveredImageAlt(null);
                                    setHoverBoxPos(null);
                                }}
                            >
                                <img className="modal-image" src={image.src} alt={image.alt} />
                                <p className="modal-image-description">{image.description}</p>

                                {hoveredImageAlt === image.alt && hoverBoxPos && (
                                    <div
                                        className="child-modal"
                                        // Dynamic positioning. Needs to be in this file to work.
                                        style={{
                                            top: hoverBoxPos.top,
                                            left: hoverBoxPos.left,
                                            transform: renderAbove ? 'translate(-50%, -100%)' : 'translateX(-50%)',

                                        }}
                                    >
                                        {image.longDescription}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ParentModal;
